<template >
  <div class="o-component o-component--expand">
    <div class="m-featured-image" :class="{ 'is-switched': props.imageText.image_alignment === 'right' }">
      <div class="m-featured-image__media">
        <picture class="a-image" style="--padding-ratio: calc(342/456)">
          <img class="a-image__img"
            :src="props.imageText.image.thumbURL+ '?width=5&height=5'"
            :data-src="props.imageText.image.thumbURL+ '?width=456&height=342'"
            :alt="props.imageText.image.alt" loading="lazy" />
        </picture>
      </div>
      <div class="m-featured-image__content">
        <h2 class="a-h5 m-featured-image__title">{{ props.imageText.title }}</h2>
        <div class="m-featured-image__text" v-html="props.imageText.text"></div>
        <a v-if="(props.imageText.button_text ?? '').length > 0 || (props.imageText.button_url ?? '').length > 0"
          :href="props.imageText.button_url">{{ props.imageText.button_text }}</a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { ImageTextBlock } from '../../helper/article';


const props = defineProps({
  imageText: {
    type: Object as PropType<ImageTextBlock>,
    required: true,
  },
})

</script>
